var React = require('react');

function UiCloseCircle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ui-close-circle"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M23,0A23,23,0,1,0,46,23,23,23,0,0,0,23,0Zm0,44A21,21,0,1,1,44,23,21,21,0,0,1,23,44Z","key":0}),React.createElement("path",{"d":"M30.48,15.32a1,1,0,0,0-1.41,0l-6.18,6.15-6.16-6.18a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l6.15,6.17L15.29,29A1,1,0,0,0,16,30.75a1,1,0,0,0,.71-.29l6.17-6.16L29,30.48a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41L24.3,22.89l6.18-6.16A1,1,0,0,0,30.48,15.32Z","key":1})])]);
}

UiCloseCircle.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 46 46"};

module.exports = UiCloseCircle;

UiCloseCircle.default = UiCloseCircle;
